export default __webpack_public_path__ + "static/989-2972f9beae07bd7e68c9269f89d379ba.gif";